// extracted by mini-css-extract-plugin
export var $animation_name = "BlogPostCard-module--$animation_name--b5f9d";
export var Post = "BlogPostCard-module--Post--4cb1c";
export var Post___featured = "BlogPostCard-module--Post___featured--e3c23";
export var Post___featured__anchor = "BlogPostCard-module--Post___featured__anchor--8feb8";
export var Post___noImage = "BlogPostCard-module--Post___noImage--849f4";
export var Post__anchor = "BlogPostCard-module--Post__anchor--1c215";
export var Post__excerpt = "BlogPostCard-module--Post__excerpt--7bea1";
export var Post__featuredImage = "BlogPostCard-module--Post__featuredImage--27e2d";
export var Post__link = "BlogPostCard-module--Post__link--826bd";
export var Post__meta = "BlogPostCard-module--Post__meta--d8eee";
export var Post__subLine = "BlogPostCard-module--Post__subLine--0770a";
export var Post__title = "BlogPostCard-module--Post__title--cdfd6";